import HttpService from "@core/services/http/http.service";
import { GetListResponse, Notification } from "@app/types";
import { RequestParams, Signal } from "@core/services/http/http.type";

class _NotificationService {
  public getList(requestParams?: RequestParams, signal?: Signal) {
    return HttpService.get<GetListResponse<Notification>>(
      "/user/api/v1/notifications",
      {
        queryParams: { ...requestParams },
        signal,
      }
    );
  }

  public markAsRead(notificationId: number) {
    return HttpService.post(`/user/api/v1/notifications/${notificationId}`);
  }

  public markAllRead() {
    return HttpService.post("/user/api/v1/notifications");
  }
}

const NotificationService = new _NotificationService();

export default NotificationService;
